export const PREVIEW_DEVICES = ['mobile', 'desktop', 'panel'] as const;
